import type { IntlShape } from 'react-intl'
import type { VoucherHeader, VoucherRowHeader } from './types'

export const voucherHeaders: VoucherHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Id',
				description: 'Table column header: Id',
			}),
		key: 'id',
		show: true,
		sortable: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tosite',
				description: 'Table column header: Voucher',
			}),
		key: 'name',
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tositteen numero',
				description: 'Table column header: Voucher number',
			}),
		key: 'number',
		show: true,
		sortable: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Päivämäärä',
				description: 'Table column header: date',
			}),
		key: 'date',
		show: true,
		sortable: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Selite',
				description: 'Table column header: Description',
			}),
		key: 'info',
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tekijä',
				description: 'Table column header: Creator',
			}),
		key: 'creatorName',
		show: true,
		sortable: true,
		type: 'string',
	},
]

export const voucherFormHeaders: VoucherHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tosite',
				description: 'Table column header: Voucher',
			}),
		key: 'name',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tositteen numero',
				description: 'Table column header: Voucher number',
			}),
		key: 'number',
		show: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Päivämäärä',
				description: 'Table column header: date',
			}),
		key: 'date',
		show: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Linkki',
				description: 'Table column header: Link',
			}),
		key: 'link',
		show: true,
		type: 'readonly',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Selite',
				description: 'Table column header: Description',
			}),
		key: 'info',
		show: true,
		type: 'string',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tekijä',
				description: 'Table column header: Creator',
			}),
		key: 'creatorName',
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tositteen tyyppi',
				description: 'Table column header: Voucher type',
			}),
		key: 'type',
		show: true,
		sortable: true,
		type: 'number',
	},
]

export const voucherDialogTableHeaders: VoucherRowHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tili',
				description: 'Table column header: Account',
			}),
		key: 'account',
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kuvaus',
				description: 'Table column header: Description',
			}),
		key: 'description',
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Selite',
				description: 'Table column header: Definition',
			}),
		key: 'definition',
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Debet',
				description: 'Table column header: Debet',
			}),
		key: 'debet',
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kredit',
				description: 'Table column header: Credit',
			}),
		key: 'credit',
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'ALV',
				description: 'Table column header: VAT',
			}),
		key: 'vat',
		show: true,
		sortable: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kustannuspaikka',
				description: 'Table column header: Cost center',
			}),
		key: 'costCentreId',
		show: true,
		sortable: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Muokkaaja',
				description: 'Table column header: Editor',
			}),
		key: 'modifierName',
		show: true,
		sortable: true,
		type: 'string',
	},
]
